import React, { useState } from "react";
import "./Slideshow.css";

const Slider = () => {
  const images = [
    "/images/sample2.png",
    "/images/firooze.png",
    "/images/ghalam.png",
    "/images/slide4.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(false);

  const changeSlide = (newIndex) => {
    setFade(true);
    setTimeout(() => {
      setCurrentIndex(newIndex);
      setFade(false);
    }, 400);
  };

  const prevSlide = () => {
    const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    changeSlide(newIndex);
  };

  const nextSlide = () => {
    const newIndex =
      currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    changeSlide(newIndex);
  };

  return (
    <div className="slider-wrapper">
      <div className="slider">
        <button className="arrow right" onClick={prevSlide}>
          ❮
        </button>

        <div className="slide-container">
          <img
            src={images[currentIndex]}
            alt={`Slide ${currentIndex}`}
            className={`slide ${fade ? "fade" : ""}`}
          />
        </div>

        <button className="arrow left" onClick={nextSlide}>
          ❯
        </button>

        <div className="dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "active" : ""}`}
              onClick={() => changeSlide(index)}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;
